import { render, staticRenderFns } from "./qcteam.vue?vue&type=template&id=5cfc4df5&scoped=true"
import script from "./qcteam.vue?vue&type=script&lang=js"
export * from "./qcteam.vue?vue&type=script&lang=js"
import style0 from "./qcteam.vue?vue&type=style&index=0&id=5cfc4df5&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5cfc4df5",
  null
  
)

export default component.exports